import { PickersCalendarHeaderProps } from '@mui/x-date-pickers/PickersCalendarHeader'
import dayjs from 'dayjs'
import { Icon, IconButton, Typography } from '../../core'
import { styled } from '../../styles'

type DatePickerHeaderProps = {
  disaplyArrows?: boolean
}

const StyledHeaderWrapper = styled('div')<DatePickerHeaderProps>(({ disaplyArrows }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: disaplyArrows ? 'space-between' : 'center',
  marginBottom: 12,
}))

const StyledHeaderInnerWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

export const CustomDatePickerHeader = (props: PickersCalendarHeaderProps<any>) => {
  const { currentMonth, onMonthChange, onViewChange, view } = props

  const disaplyArrows = view === 'day'

  const previousMonth = dayjs(currentMonth).subtract(1, 'month')
  const nextMonth = dayjs(currentMonth).add(1, 'month')

  return (
    <StyledHeaderWrapper disaplyArrows={disaplyArrows}>
      {disaplyArrows && (
        <IconButton
          onClick={() => onMonthChange?.(previousMonth, 'right')}
          size="small"
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
        >
          <Icon icon="chevron_left" />
        </IconButton>
      )}

      <StyledHeaderInnerWrapper>
        <Typography variant={'body2Medium'}>{dayjs(currentMonth).format('MMMM YYYY')}</Typography>
        <IconButton
          onClick={() => onViewChange?.('year')}
          size="small"
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
        >
          <Icon icon="keyboard_arrow_down" />
        </IconButton>
      </StyledHeaderInnerWrapper>

      {disaplyArrows && (
        <IconButton
          onClick={() => onMonthChange?.(nextMonth, 'left')}
          size="small"
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
        >
          <Icon icon="chevron_right" />
        </IconButton>
      )}
    </StyledHeaderWrapper>
  )
}
